import { useState } from 'react';
import { Upload, Spin, message } from 'antd';
import get from 'lodash/get';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import { getPresignedUrl1, postUploadVideoDetails } from '../../redux/actions/doctorAction';

const SingleVideoUpload = (props) => {
  const { userVideo, onUploadDone, setUserVideo, user } = props;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [videoDetails, setVideoDetails] = useState(null);

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const handleRemove = () => {
    setUserVideo(null);
    setVideoDetails(null);
  };

  const beforeUpload = async (file) => {
    const isLt100MB = file.size / 1024 / 1024 < 100;
    if (!isLt100MB) {
      setError('File size must be smaller than 100MB!');
      message.error('File size must be smaller than 100MB!');
      return false;
    }
    try {
      setLoading(true);
      setError(null);
      const res = await getPresignedUrl1({
        fileName: file.name,
        fileType: file.type,
      });
      const uploadUrl = res?.url;
      const s3Key = res?.key;
      await axios.put(uploadUrl, file, {
        headers: {
          'Content-Type': file.type,
        },
      });
      const videoPublicUrl = uploadUrl.split('?')[0];
      const details = await postUploadVideoDetails(user?.email, file, s3Key, videoPublicUrl);
      setVideoDetails(details);
      setUserVideo(details);
      onUploadDone(details);
    } catch (err) {
      console.error('Upload failed:', err);
      message.error('Upload failed. Please try again.');
      setError('Upload failed. Please try again.');
    } finally {
      setLoading(false);
    }
    return Upload.LIST_IGNORE;
  };

  return (
    <Spin spinning={loading}>
      {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
      {videoDetails?.url || userVideo?.url ? (
        <div>
          <div style={{ position: 'relative', width: 200, height: 200 }}>
            <video src={videoDetails?.url || userVideo?.url} width={200} height={200} controls />
            <div
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                cursor: 'pointer',
                background: '#fff',
                padding: '4px',
              }}
              onClick={handleRemove}
            >
              Remove
            </div>
          </div>
        </div>
      ) : (
        <Upload
          name="file"
          listType="picture-card"
          className="avatar-uploader"
          showUploadList={false}
          accept="video/*"
          beforeUpload={beforeUpload}
        >
          {uploadButton}
        </Upload>
      )}
    </Spin>
  );
};

export default SingleVideoUpload;
